// import { IconInfo } from '@americanexpress/dls-react';
import React from 'react';
import { useOneCmsLocaleSearchObj } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

const noLocaleFallbackError =
  'Sorry, our systems are not responding. Please try your request again. If you see this message repeatedly please call the number on the back of your Card for assistance.';

export const NotRespondingAlert2 = () => {
  const searchCopy = useOneCmsLocaleSearchObj();
  return (
    <div
      className="alert alert-neutral alert-dialog border-0 stack-1"
      role="alert"
    >
      {/* <IconInfo /> */}
      <p className="alert-subtitle">
        {searchCopy?.no_connection || noLocaleFallbackError}
      </p>
    </div>
  );
};
